import { ChainID } from '@ankr.com/chains-list';
import { Box, BoxProps } from '@mui/material';
import { EBlockchain } from 'multirpc-sdk';
import { forwardRef } from 'react';

import { useChainIcon } from 'uiKit/hooks/useChainIcon';

interface INetworkIconProps extends Pick<BoxProps, 'sx' | 'className'> {
  network?: EBlockchain;
  alt?: string;
}

export const NetworkIcon = forwardRef<HTMLImageElement, INetworkIconProps>(
  function NetworkIcon({ network, alt = network, sx, ...restProps }, ref) {
    const networkIcon = useChainIcon(network as unknown as ChainID);

    return (
      <Box
        {...restProps}
        ref={ref}
        component="img"
        src={networkIcon}
        alt={alt}
        sx={{
          width: '1em',
          height: '1em',
          ...sx,
        }}
      />
    );
  },
);
